module.exports = __webpack_public_path__ + "static/media/Tractor.f5e83a0e.svg";